import React from "react";
import { SEO } from "@bluefin/components";
import { Grid, Segment, Embed } from "semantic-ui-react";
import { graphql } from "gatsby";

import WebsiteLayout from "../components/WebsiteLayout.jsx";
import "../style/contact-us.css";

export default class ContactUsPage extends React.PureComponent {
  render() {
    const { data } = this.props;
    const { fishermanBusiness, fishermanBusinessWebsitePage } = data;

    return (
      <WebsiteLayout>
        <SEO
          businessName={fishermanBusiness.name}
          pageName={fishermanBusinessWebsitePage.title}
          title={fishermanBusinessWebsitePage.seoTitle}
          description={fishermanBusinessWebsitePage.description}
          ogUrl={"https://www.bv-nh.com/contact-us/"}
        />
        <Grid
          className={"custom-page-contact-us custom-page-grid"}
          style={{}}
          stackable={true}
        >
          <Grid.Row
            className={"eemofkmbmghfelmp"}
            style={{ padding: 16 }}
            columns={1}
          >
            <Grid.Column className={"hlggllgiejaielen"} style={{ padding: 16 }}>
              <Segment
                className={""}
                style={{
                  border: "none",
                  boxShadow: "none",
                  background: "none",
                }}
              >
                <React.Fragment
                  key={"JSON__0aa551c3-856b-4936-bbb1-bc1eaf12fa5d"}
                >
                  <Embed
                    url={
                      "https://phorest.com/book/salons/bellaviaggiosalonsspas1/book/consultations/form?lead_source=WEBSITE"
                    }
                    defaultActive={true}
                    className={""}
                  />
                </React.Fragment>
              </Segment>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </WebsiteLayout>
    );
  }
}

export const query = graphql`
  query {
    fishermanBusiness {
      name
    }
    fishermanBusinessWebsitePage(_id: { eq: 38586 }) {
      title
      seoTitle
      description
    }
  }
`;
